import React from 'react';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { Text } from '../../Text';
import { Icon } from '../../Icon';
import { View } from 'react-native';
export const Participants = ({ participants }) => {
    const [creator, ...others] = participants;
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container },
        React.createElement(Icon, { name: 'people', size: 23 }),
        React.createElement(Text, { style: [styles.participant, styles.margin], type: 'body', size: 'md', weight: 'semibold' }, creator),
        React.createElement(Text, { style: styles.and, type: 'body', size: 'md', weight: 'regular' }, "and"),
        others.length > 1 ? (React.createElement(Text, { style: styles.participant, type: 'body', size: 'md', weight: 'semibold' },
            others.length,
            " others")) : (React.createElement(Text, { style: styles.participant, type: 'body', size: 'md', weight: 'semibold' }, participants[1]))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: size.G
    },
    participants: {
        flex: 1
    },
    and: {
        marginHorizontal: 4
    },
    participant: {
        color: color.invert2.p100
    },
    margin: {
        marginLeft: size.C
    }
}));
//# sourceMappingURL=Participants.js.map